import { CallbackObject } from 'api/core/get-page-function';
import { GetProductVm } from './get-product.vm';
import { plainToClass } from 'class-transformer';
import { AxiosResponse } from 'axios';
import { instance } from 'api/core';

export const getProduct = async (product: string, callback: CallbackObject<GetProductVm>) => {
  const config: Record<string, any> = {
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      limit: 50,
    },
  };

  try {
    const res: AxiosResponse = await instance.get(`/catalog/products/${product}`, config);
    callback.success(plainToClass(GetProductVm, res.data));
  } catch (err) {
    if (callback.error) callback.error(err);
  }
};
